/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Timecode_Options_LabelInputs */



/**
* | output |
* | --- |
* | "Timecode Options" |
*
* @param {Transcript_Export_Timecode_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_timecode_options_label = /** @type {((inputs?: Transcript_Export_Timecode_Options_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Timecode_Options_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options de timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timecode-Optionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni del timecode")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры временного кода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードオプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de código de tempo")
	return /** @type {LocalizedString} */ ("Timecode Options")
});